// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"sidebar-component_uk-open__bK5iv","grecaptcha-badge":"sidebar-component_grecaptcha-badge__NM9aC","sidebar":"sidebar-component_sidebar__55cCy"};
    if(module.hot) {
      // 1793877041782
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  